<div>
  <div class="wiz-content">
    <h1>{{'wizard.step-8.title' | translate}}</h1>
    <div class="wiz-content-text">
      <p>{{'wizard.step-8.p-1' | translate}}</p>
      <p>{{'wizard.step-8.p-2' | translate}}</p>
    </div>
    <button class="primary-btn" routerLink="/home">{{'wizard.step-8.btn-enter' | translate}}</button>
  </div>
</div>
